import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import getRealTimeWarehouseInventory from "@insite/client-framework/Store/Data/RealTimeInventory/Handlers/GetRealTimeWarehouseInventory";
import translate from "@insite/client-framework/Translate";
/* import {
    AvailabilityDto,
    AvailabilityMessageType,
    ProductSettingsModel,
    WarehouseDto,
} from "@insite/client-framework/Types/ApiModels"; - Store Custom Code */
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody, { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import { DataTableCellBaseProps } from "@insite/mobius/DataTable/DataTableCellBase";
import DataTableHead, { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow, { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconWrapper } from "@insite/mobius/Icon";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Check from "@insite/mobius/Icons/Check";
import X from "@insite/mobius/Icons/X";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import safeColor from "@insite/mobius/utilities/safeColor";
// import React, { useState } from "react"; // Store Custom Code
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

/* Store Custom Code - Start */
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import {
    AvailabilityDto,
    AvailabilityMessageType,
    ProductInventoryDto,
    ProductSettingsModel,
    WarehouseDto,
} from "@insite/client-framework/Types/ApiModels";
import getColor from "@insite/mobius/utilities/getColor";
import { getPolicy } from "@store/Framework/Store/Store/Data/getPolicy";
import getWidgetComponent from "@store/Framework/Common/Utilities/getWidgetComponent";
import find from "lodash/find";
import orderBy from "lodash/orderBy";
import React, { useEffect, useState } from "react";
import { Result } from "@store/Extensions/Store/Handlers/RealTimeInventory/GetRealTimeWarehouseInventory";
/* Store Custom Code - End */

interface OwnProps {
    productId: string;
    availability?: AvailabilityDto;
    unitOfMeasure: string;
    trackInventory: boolean;
    isProductDetailsPage?: boolean;
    failedToLoadInventory?: boolean;
    extendedStyles?: ProductAvailabilityStyles;
    // Store Custom Code
    isAvailabilityTable?: string;
    inventory?: ProductInventoryDto | undefined;
    qtyOrdered?: number;
    qtyOnHand?: number;
    warehouseNetworkQty?: string;
}

/* Store Custom Code - Start */
const mapStateToProps = (state: ApplicationState) => {
    const currentPage = getCurrentPage(state);
    let inventoryType = {} as any;

    if (currentPage.type === "MyListsDetailsPage") {
        inventoryType = state.pages?.myListDetails?.productInfosByWishListLineId;
        // } else if (currentPage.type === "ProductListPage") {
        //     inventoryType = state.pages?.productList?.productInfosByProductId;
    }

    return {
        productSettings: getSettingsCollection(state).productSettings,
        showInventory: state.context.showInventory,
        currentPageType: currentPage.type,
        warehousesInventory: inventoryType,
        canSeeNetwork: getPolicy(state, "Inventory.CanSeeNetworkInventory"),
    };
};
/* Store Custom Code - End */

const mapDispatchToProps = {
    getRealTimeWarehouseInventory,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ProductAvailabilityStyles {
    container?: GridContainerProps;
    messageGridItem?: GridItemProps;
    availabilityByWarehouseLinkGridItem?: GridItemProps;
    inventoryMessage?: InjectableCss;
    messageText?: TypographyPresentationProps;
    realTimeText?: TypographyPresentationProps;
    errorWrapper?: InjectableCss;
    errorText?: TypographyPresentationProps;
    availabilityByWarehouseLink?: LinkPresentationProps;
    availabilityByWarehouseModal?: ModalPresentationProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    availabilityByWarehouseTable?: DataTableProps;
    availabilityByWarehouseTableHead?: DataTableHeadProps;
    availabilityByWarehouseTableHeader?: DataTableHeaderProps;
    availabilityByWarehouseTableBody?: DataTableBodyProps;
    availabilityByWarehouseTableRow?: DataTableRowProps;
    availabilityByWarehouseTableCell?: DataTableCellBaseProps;
    // Store Custom Code
    inventoryError?: TypographyPresentationProps;
}

export const productAvailabilityStyles: ProductAvailabilityStyles = {
    container: {
        gap: 0,
        css: css`
            flex-grow: 0;
        `,
    },
    messageGridItem: { width: 12 },
    availabilityByWarehouseLinkGridItem: { width: 12 },
    availabilityByWarehouseModal: {
        size: 400,
        cssOverrides: {
            modalContent: css`
                padding: 0;
            `,
            modalTitle: css`
                padding: 10px 10px 10px 20px;
            `,
            headlineTypography: css`
                font-size: 20px;
                margin-bottom: 0;
            `,
        },
    },
    centeringWrapper: {
        css: css`
            height: 100px;
            width: 100%;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: 0 auto;
        `,
    },
    messageText: {
        css: css`
            width: 100%;
            color: ${getColor("common.background")}; /* Store Custom Code */
            ${wrapInContainerStyles}
        `,
    },
    realTimeText: {
        weight: "bold",
        css: css`
            display: inline-block;
            text-align: left;
            min-width: 25px;

            &::after {
                overflow: hidden;
                display: inline-block;
                vertical-align: bottom;
                animation: ellipsis steps(4, end) 900ms infinite 1s;
                content: "\\2026";
                width: 0;
            }

            @keyframes ellipsis {
                to {
                    width: 1.25em;
                }
            }
        `,
    },
    errorText: {
        weight: "bold",
    },
    // Store Custom Code
    inventoryError: {
        css: css`
            border: 1px solid ${getColor("warning.main")};
            padding: 5px 10px;
            margin-top: 15px;
            color: ${getColor("warning.main")};
        `,
    },
};

const InventoryMessage = styled.div<{ color: string }>`
    display: flex;
    align-items: center;

    /* Store Custom Code - Start */
    padding: 5px 10px;
    border-radius: 2px;
    background-color: ${props => safeColor(resolveColor(props.color, props.theme)).rgb().string()};

    /* Store Custom Code - End */
`;

/* Store Custom Code - Moved getAvailabilityColor() */

const getAvailabilityIcon = (productSettings: ProductSettingsModel, availability?: AvailabilityDto) => {
    if (!productSettings.showInventoryAvailability) {
        return undefined;
    }

    const availabilityType = availability?.messageType;
    if (availabilityType === AvailabilityMessageType.OutOfStock) {
        return X;
    }

    if (availabilityType === AvailabilityMessageType.LowStock) {
        return AlertTriangle;
    }

    return Check;
};

const showLink = (
    availability: AvailabilityDto | undefined,
    trackInventory: boolean,
    productSettings: ProductSettingsModel,
    isProductDetailsPage?: boolean,
): boolean => {
    if (
        !availability ||
        availability.messageType === AvailabilityMessageType.NoMessage ||
        !trackInventory ||
        !productSettings.showInventoryAvailability ||
        !productSettings.displayInventoryPerWarehouse
    ) {
        return false;
    }

    if (!productSettings.displayInventoryPerWarehouseOnlyOnProductDetail) {
        return true;
    }

    return !!isProductDetailsPage;
};

const ProductAvailability = ({
    productId,
    availability,
    unitOfMeasure,
    trackInventory,
    productSettings,
    isProductDetailsPage,
    getRealTimeWarehouseInventory,
    failedToLoadInventory,
    showInventory,
    extendedStyles,
    // Store Custom Code
    isAvailabilityTable,
    qtyOrdered,
    qtyOnHand,
    currentPageType,
    warehousesInventory,
    inventory,
    warehouseNetworkQty,
    canSeeNetwork,
}: Props) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [warehouses, setWarehouses] = useState<WarehouseDto[] | null | undefined>(undefined); // Store Custom Code
    const [errorMessage, setErrorMessage] = useState("");
    const [networkMsg, setNetworkMsg] = useState<string | undefined>(undefined); // Store Custom Code
    const [networkAvailability, setNetworkAvailability] = useState(0); // Store Custom Code
    const [isLoading, setIsLoading] = useState(false);
    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };

    /* Store Custom Code - Start */
    useEffect(() => {
        if (
            (currentPageType === "ProductListPage" ||
                currentPageType === "ProductDetailsPage" ||
                currentPageType === "QuickOrderPage" ||
                currentPageType === "HomePage") &&
            inventory &&
            inventory?.inventoryWarehousesDtos
        ) {
            const networkWarehouses = inventory?.inventoryWarehousesDtos[0]?.warehouseDtos;
            doSetInventory(inventory, networkWarehouses ?? []);
        }
    }, [currentPageType, inventory]);

    useEffect(() => {
        if (currentPageType === "MyListsDetailsPage" && warehousesInventory) {
            const currentListItem = find(warehousesInventory, warehouse => {
                return (warehouse as any).productId === productId;
            });
            const networkWarehousesList = (currentListItem as any)?.inventory?.inventoryWarehousesDtos[0]
                ?.warehouseDtos;
            doSetInventory((currentListItem as any)?.inventory, networkWarehousesList);
        }
    }, [currentPageType, warehousesInventory]);

    useEffect(() => {
        if (currentPageType === "CartPage" || currentPageType === "SavedOrderDetailsPage") {
            let _networkAvailability = 0;
            if (warehouseNetworkQty && warehouseNetworkQty.length >= 1) {
                _networkAvailability = parseInt(warehouseNetworkQty, 10);
                setNetworkAvailability(_networkAvailability);
            }
        }
    }, [currentPageType, warehouseNetworkQty]);

    const doSetInventory = (_inv: ProductInventoryDto, _whList: WarehouseDto[]) => {
        setWarehouses(_whList);
        if (_inv?.additionalResults?.networkQty) {
            setNetworkAvailability(parseInt(_inv.additionalResults.networkQty, 10));
        } else {
            let _networkAvailability = 0;
            _whList?.forEach((x: any) => {
                _networkAvailability += x.qty;
            });
            setNetworkAvailability(_networkAvailability);
        }

        if (_inv?.additionalResults?.networkMsg) {
            setNetworkMsg(_inv.additionalResults.networkMsg);
        }
    };

    const networkInventory = () => `${translate("Network")} : ${networkMsg ?? networkAvailability}`;

    const getAvailabilityColor = (productSettings: ProductSettingsModel, availability?: AvailabilityDto) => {
        if (!productSettings.showInventoryAvailability) {
            return "common";
        }

        const availabilityType = availability?.messageType;
        if (availabilityType === AvailabilityMessageType.OutOfStock && (!canSeeNetwork || networkAvailability === 0)) {
            return "unavailable";
        }

        if (
            (availabilityType === AvailabilityMessageType.OutOfStock && networkAvailability > 0) ||
            availabilityType === AvailabilityMessageType.LowStock
        ) {
            return "warning";
        }

        return "success";
    };

    const networkAndLocalAvailabilityMessage = () => {
        if (qtyOrdered! > networkAvailability) {
            return (
                <Typography {...styles.inventoryError}>{translate("CartLineInsufficientNetworkInventory")}</Typography>
            );
        }
        if (qtyOrdered! > qtyOnHand!) {
            return (
                <Typography {...styles.inventoryError}>{translate("CartLineInsufficientLocalInventory")}</Typography>
            );
        }
    };
    /* Store Custom Code - End */

    const viewAvailabilityByWarehouseClickHandler = () => {
        setIsLoading(true);
        setModalIsOpen(true);
        getRealTimeWarehouseInventory({
            productId,
            unitOfMeasure,
            expand: ["warehouses"],
            onComplete: (result: Result /* Store Custom Code */) => {
                /* Store Custom Code - Start */
                if (result.additionalResults) {
                    setNetworkMsg(result.additionalResults.networkMsg);
                    setNetworkAvailability(result.additionalResults.networkQty);
                }
                /* Store Custom Code - End */
                setWarehouses(result.warehouses);
                setErrorMessage(result.errorMessage);
                setIsLoading(false);
            },
        });
    };

    const color = getAvailabilityColor(productSettings, availability);
    const iconSrc = getAvailabilityIcon(productSettings, availability);

    const [styles] = useState(() => mergeToNew(productAvailabilityStyles, extendedStyles));

    // Store Custom Code - Removed return null;
    /* Store Custom Code - Start */
    const availabilityLabel = () => {
        const networkInv = networkInventory();
        const networkLabel = !canSeeNetwork ? `` : ` | ${networkInv}`;
        const renderAvailabilityLabel = () => {
            return <>{translate("Available on order")}</>;
        };

        return (availability?.messageType === AvailabilityMessageType.OutOfStock && networkAvailability === 0) ||
            (availability?.messageType === AvailabilityMessageType.OutOfStock && !canSeeNetwork) ? (
            renderAvailabilityLabel()
        ) : (
            <>
                {availability?.message}
                {networkLabel}
            </>
        );
    };
    /* Store Custom Code - End */

    if (failedToLoadInventory) {
        return (
            <StyledWrapper {...styles.errorWrapper}>
                <Typography {...styles.errorText} data-test-selector="inventoryLoadFailedMessage">
                    {siteMessage("RealTimeInventory_InventoryLoadFailed")}
                </Typography>
            </StyledWrapper>
        );
    }

    let inventoryTextComponent = <Typography {...styles.realTimeText} />;
    if (availability?.messageType !== AvailabilityMessageType.NoMessage && availability?.message?.length) {
        inventoryTextComponent = (
            <InventoryMessage color={color} {...styles.inventoryMessage}>
                {/* Store Custom Code - Removed Icon */}
                <Typography {...styles.messageText} data-test-selector="availabilityMessage">
                    {availabilityLabel() /* Store Custom Code */}
                </Typography>
            </InventoryMessage>
        );
    } else if (availability) {
        inventoryTextComponent = <></>;
    }

    /* Store Custom Code - Start */
    const sortedWarehouses = orderBy(warehouses, ["name"]);
    const ProductDetailsSectionTitle = getWidgetComponent("ProductDetails/ProductDetailsSectionTitle");
    /* Store Custom Code - End */

    return (
        <GridContainer {...styles.container}>
            {/* Store Custom Code - Start */}
            {(isAvailabilityTable === "false" || isAvailabilityTable === undefined) && (
                <GridItem {...styles.messageGridItem}>{inventoryTextComponent}</GridItem>
            )}
            {isAvailabilityTable === "true" &&
                canSeeNetwork &&
                showLink(availability, trackInventory, productSettings, isProductDetailsPage) && (
                    <>
                        <GridItem {...styles.availabilityByWarehouseLinkGridItem}>
                            <ProductDetailsSectionTitle sectionTitleValue={translate("Inventory")} />
                        </GridItem>
                        <GridItem {...styles.availabilityByWarehouseLinkGridItem}>
                            {/* Store Custom Code - Removed Link */}
                            <DataTable
                                {...styles.availabilityByWarehouseTable}
                                data-test-selector="availabilityByWarehouseModal"
                            >
                                <DataTableHead {...styles.availabilityByWarehouseTableHead}>
                                    <DataTableHeader {...styles.availabilityByWarehouseTableHeader}>#</DataTableHeader>
                                    <DataTableHeader {...styles.availabilityByWarehouseTableHeader}>
                                        {translate("Warehouse")}
                                    </DataTableHeader>
                                    <DataTableHeader {...styles.availabilityByWarehouseTableHeader}>
                                        {translate("QTY")}
                                    </DataTableHeader>
                                </DataTableHead>
                                <DataTableBody {...styles.availabilityByWarehouseTableBody}>
                                    {sortedWarehouses?.map(warehouse => (
                                        <DataTableRow {...styles.availabilityByWarehouseTableRow} key={warehouse.name}>
                                            <DataTableCell {...styles.availabilityByWarehouseTableCell}>
                                                {warehouse.name}
                                            </DataTableCell>
                                            <DataTableCell
                                                {...styles.availabilityByWarehouseTableCell}
                                                data-test-selector="warehouseAvailabilityModal_Description"
                                            >
                                                {warehouse.description}
                                            </DataTableCell>
                                            <DataTableCell
                                                {...styles.availabilityByWarehouseTableCell}
                                                data-test-selector="warehouseAvailabilityModal_Quantity"
                                            >
                                                {warehouse.message ?? warehouse.qty}
                                            </DataTableCell>
                                        </DataTableRow>
                                    ))}
                                </DataTableBody>
                            </DataTable>
                        </GridItem>
                    </>
                )}
            {/* Store Custom Code - End */}
        </GridContainer>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductAvailability);
